import React from "react";

export const Button = ({
  type,
  handleClick,
  disabled,
  className,
  icon,
  children,
  variant,
  block,
  ...rest
}) => (
  <button
    type={type}
    onClick={handleClick}
    disabled={disabled}
    // Both interpolations were unguarded, so a button with no variant and no
    // className rendered `class="btn btn-undefined undefined"` -- two junk
    // classes on every such button, and `btn-undefined` is what a variant rule
    // would have to compete with.
    className={["btn", variant && `btn-${variant}`, className]
      .filter(Boolean)
      .join(" ")}
    style={{ width: block ? `100%` : `auto` }}
    {...rest}
  >
    {icon && icon}
    {children}
  </button>
);

export default Button;
